export default __webpack_public_path__ + "static/media/4357.56f79083.png";